import { Alert, Table } from "react-bootstrap";
import Loader from "./Spinner.component";

function ConfigTable({
  configedAlerts,
  days,
  isLoading,
  alertsNumber,
  from,
  to,
}) {
  if (isLoading) return <Loader type="small" />;

  if (alertsNumber === 0) return <Alert>No Data to Show</Alert>;

  return (
    <>
      <div className="pb-2 ">
        {days ? (
          <h4>Alerts last {days} days</h4>
        ) : (
          <h5>
            Alerts from {from} to {to}
          </h5>
        )}
        <hr style={{ width: "700px" }} />
      </div>

      <div>
        <p>Alerts Number : {alertsNumber}</p>
      </div>
      <div style={{ overflow: "auto", maxHeight: "50vh" }}>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Ticker</th>
              <th>Appearence</th>
              <th>Types</th>
            </tr>
          </thead>
          <tbody>
            {configedAlerts.map((item, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{item.ticker}</td>
                <td>{item.appearence}</td>
                <td>
                  {Object.keys(item.types).map((key, i) => (
                    <span className="p-1 bg-white m-1  rounded" key={i}>
                      {key}{" "}
                      <span className="badge bg-secondary rounded-pill">
                        {item.types[key]}
                      </span>
                    </span>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default ConfigTable;
